function getFrameParams() {
  var url = window.location.href;
  var params = {};
  var urlParams = [];
  if (url.indexOf("#") !== -1) {
    var paramsArr = url.split("#");
    paramsArr.forEach(function(item) {
      if (item.indexOf("?") !== -1) {
        var urlItem = item.slice(item.indexOf("?") + 1).split("&");
        urlItem.forEach(function(element) {
          var datas = element.split("=");
          params[datas[0]] = datas[1];
        });
      }
    });
  } else {
    urlParams = url.slice(url.indexOf("?") + 1).split("&");
    urlParams.forEach(
      function(element) {
        var datas = element.split("=");
        params[datas[0]] = datas[1];
      }.bind(this)
    );
  }
  return params;
}

module.exports = getFrameParams;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/getUrlParams.js